import React from 'react';
import Scrollspy from 'react-scrollspy';

const ScrollBarNav = () => {

return(

    
        <div style={{position: "absolute"}}>
        <div className="dotwrapper" style={{left: "20px", 
             overflow: "visible", display: "inline-flex", justifyContent: "space-evenly", flexDirection: "column", zIndex: "1", position:"relative", width: "100%", backgroundColor: "transparent"}}>
            <Scrollspy offset={-9} style={{listStyle:"none"}} items={['home', 'portfolio', 'resume', 'blog', 'contact']} currentClassName="is-current">
                <li><a href="#home"><span className="menutext" style={{ marginLeft: "5px", display: "inline-block", fontSize: "24px"}}>Home</span></a></li>
                <li><a href="#portfolio"><span className="menutext"  style={{ marginLeft: "5px", display: "inline-block", fontSize: "24px" }}>Portfolio</span></a></li>
                <li><a href="#resume"><span className="menutext" style={{ marginLeft: "5px", display: "inline-block", fontSize: "24px" }}>Résumé</span></a></li>
                <li><a href="#blog"><span className="menutext" style={{ marginLeft: "5px", display: "inline-block", fontSize: "24px"}}>Blog</span></a></li>
                <li><a href="#contact"><span className="menutext" style={{ marginLeft: "5px", display: "inline-block", fontSize: "24px" }}>Contact</span></a></li>
        </Scrollspy>
        </div>
        
    </div>

   

    )

    
}


export default ScrollBarNav; 
